const translations = {
  "en": {
    "(≈$%{var0}/mo)": "(≈$%{var0}/mo)",
    "Contact Us": "Contact Us",
    "Current Plan": "Current Plan",
    "Ed Complete Annual": "Ed Complete Annual",
    "Purchase failed.": "Purchase failed.",
    "Renew": "Renew",
    "View all plans": "View all plans",
    "What Ed handled for you": "What Ed handled for you"
  },
  "zh-tw": {
    "(≈$%{var0}/mo)": "(≈$%{var0}/月)",
    "Contact Us": "聯絡我們",
    "Current Plan": "目前方案",
    "Ed Complete Annual": "Ed Complete 年度",
    "Purchase failed.": "購買失敗。",
    "Renew": "續訂",
    "View all plans": "查看所有方案",
    "What Ed handled for you": "Ed 為你處理的事項"
  }
};

export default translations;
